export const viewportElementKeys = [
	'axial',
	'sagittal',
	'coronal',
	'volume',
] as const;

export type ViewportElementKey = (typeof viewportElementKeys)[number];
